import { createAction } from '@ngrx/store';

export const loggedInSuccess = createAction('[User] Logged In Success');

export const loggedOutSuccess = createAction('[User] Logged Out Success');

export const beforeCloseApplication = createAction('[User] Before Close Application');

export const afterHideApplication = createAction('[User] After Hide Application');
